import { useQuery } from '@tanstack/react-query';

import type { SalesforceSurchargePeriod } from '~/types/surcharges';

import ReservationService from '~/services/ReservationService';

import { reservationQueryKeys } from './reservationQueryKeys';

export function useGetSalesforceSurcharges(offerId: string | null) {
  return useQuery({
    queryKey: reservationQueryKeys.salesforceSurcharges(offerId),
    queryFn: async () => {
      const { result: surcharges } = await ReservationService.getSalesforceSurcharges(offerId);
      return surcharges.map((s: SalesforceSurchargePeriod) => ({
        ...s,
        accumulate: Boolean(s.accumulate),
        overlapping: Boolean(s.overlapping),
      }));
    },
    enabled: !!offerId,
  });
}
